<template>
  <div
    class="custom-select"
    :tabindex="tabindex"
    @keydown.down="
      onArrowDown();
      hover = false;
    "
    @keydown.up="
      onArrowUp();
      hover = false;
    "
    @keydown.enter="
      onEnter();
      hover = false;
    "
    @keydown.esc="open = false"
  >
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <span>{{ selectedTime ? formatDate(selectedTime) : selected }}</span>
    </div>
    <div
      class="items shadow"
      @mouseleave="
        hover = false;
        arrowCounter = -1;
      "
      :class="{ selectHide: !open }"
    >
      <div
        v-for="(option, i) of options"
        :key="i"
        @mouseenter="
          arrowCounter = i;
          hover = true;
        "
        @mouseleave="hover = false"
        @mousemove="
          arrowCounter = i;
          hover = true;
        "
        :class="{ 'is-active': i === arrowCounter }"
      >
        <span
          @click="
            selected = option.text;
            $emit('input', selected);
            open = false;
          "
          v-if="!option.fillable"
          >{{ option.text }}</span
        >
        <date-picker
          v-if="option.fillable"
          class="gray-placeholder time-picker"
          type="datetime"
          valueType="format"
          format="DD-MM-YYYY HH:mm"
          placeholder="Enter date"
          :append-to-body="false"
          v-model="selectedTime"
          :confirm="true"
          @confirm="open = false"
          prefix-class="xmx"
          :minute-step="5"
        ></date-picker>
      </div>
    </div>
  </div>
</template>

<script>
/*     @focus="open = true; focus = true"
    @blur="open = false; focus = false" */
import DatePicker from "vue2-datepicker";
// import "@/styles/datetime.css";

export default {
  name: "TimeSelectInput",
  props: {
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    value: {
      required: true,
    },
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      options: [
        { text: "ASAP", fillable: false },
        { text: "Select Date Time", fillable: true },
      ],
      selected: "",
      selectedTime: "",
      open: false,
      arrowCounter: -1,
      now: "",
    };
  },
  mounted() {
    this.selected = this.options[0].text;
    this.now = new Date();
    this.$emit("input", this.selected);
  },
  methods: {
    formatDate(date){
      return date;
      //return moment(date).format("Y-MM-DD HH:mm");
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.options.length - 1) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.arrowCounter = -1;
      this.open = false;
      this.$emit("input", this.selected);
    },
  },
  watch: {
    value: function (val) {
      if (val !== "") this.selected = val;
      else this.selected = this.options[0].text;
      if (this.selected === "ASAP") this.selectedTime = "";
    },
    selectedTime: function (val) {
      if (this.selectedTime) {
        this.selected = val;
        this.$emit("input", val);
      } else {
        this.selected = this.options[0].text;
        this.selectedTime = "";
      }
    },
    open: function (val) {
      if (val) document.addEventListener("click", this.handleClickOutside);
      else document.removeEventListener("click", this.handleClickOutside);
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: start;
  outline: none;
  float: inline-start;
}

.custom-select .selected {
  background-color: #f7f8fa;
  width: 100%;
  border-radius: 10px;
  color: #788e98;
  border: 1px solid #c1c5d8;
  cursor: pointer;
  user-select: none;
  padding: 16px 15px;
  float: inline-start;

  span {
    color: #2f434c;
  }
}

.custom-select:focus {
  .selected {
    border-color: #2f434c;
  }
}

.custom-select .selected span {
  width: max-content;
  float: inline-start;
  font-size: 14px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 26px;
  inset-inline-end: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #c1c5d8 transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 10px;
  overflow: show;
  position: absolute;
  background-color: #ffffff;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: calc(100% + 8px);
  padding: 10px;
  z-index: 1;
}

.custom-select .items div {
  color: #fff;
  cursor: pointer;
  user-select: none;
  color: #2f434c;
  font-size: 14px;
  float: inline-start;
  width: 100%;

  span {
    padding: 15px 18px;
    width: 100%;
    float: inline-start;
  }

  .formatted-time-input {
    float: inline-start;
    padding: 15px 18px;
    width: 100%;
    max-width: none;
    background-color: transparent;
    border: none;
  }
}

.custom-select .items div:not(:last-child) {
  border-bottom: 1px solid #e0e0df;
}

.custom-select .items div:last-child {
  border-radius: 0 0 8px 8px;
}

.custom-select .items div:first-child {
  border-radius: 8px 8px 0 0;
}

// .custom-select .items div:hover {
//   background-color: #f7f8fa;
// }

.selectHide {
  display: none;
}

.is-active {
  background: #f7f8fa;
}

input {
  max-width: none;
}

.time-picker {
  z-index: 99;
}
</style>
